<template>
    <transition name="el-fade-in-linear">
        <div v-show="showMain" class="transition-box">
            <div id="formblock">
                <el-form label-position="top" label-width="80px" :model="searchForm">
                    <el-row :gutter="30">
                        <el-col :span="5">
                            <el-form-item label="公司/門店">
                                <el-select v-model="searchForm.VENDOR_ID" style="width:100%;" :disabled="Roledisabled">
                                    <el-option v-for="item in compOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="日期範圍">
                                <el-date-picker v-model="searchForm.Date" type="daterange" range-separator="~" start-placeholder="Start Date" end-placeholder="End Date" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="使用者">
                                <el-select v-model="searchForm.USER_ID" style="width:100%;" clearable>
                                    <el-option v-for="item in userOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="功能項目">
                                <el-select v-model="searchForm.SYS_FUNC" style="width:100%;" clearable>
                                    <el-option v-for="item in funcOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row type="flex" justify="center">
                    <el-col :span="6" style="margin-top:auto;margin-bottom:auto;">
                        <el-button style="width: 100%" type="primary" @click="onSearch" v-show="store.getters.check_auth('SEARCH')">Search</el-button>
                    </el-col>
                </el-row>
            </div>
            <div id="datablock">
                <div ref="table" style="margin-top:10px;"></div>
            </div>

            <!--Parameters-->
            <el-dialog :title="dialogTitle" width="40%" v-model="dialogFormVisible" top="5vh"
                       @opened="onDialogOpen" center label-width="" :lock-scroll="false" :close-on-click-modal="false">
                <el-form :model="form" :rules="rules" label-width="" ref="formRef" :inline-message="true" label-position="top">
                    <el-form-item label="Parameter 1" prop="FIELD_1">
                        <el-input v-model="form.FIELD_1" type="textarea" :rows="6" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="Parameter 2" prop="FIELD_2">
                        <el-input v-model="form.FIELD_2" type="textarea" :rows="6" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="Parameter 3" prop="FIELD_3">
                        <el-input v-model="form.FIELD_3" type="textarea" :rows="6" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="Parameter 4" prop="FIELD_4">
                        <el-input v-model="form.FIELD_4" type="textarea" :rows="6" disabled></el-input>
                    </el-form-item>
                </el-form>
                <template #footer class="dialog-footer">
                    <el-button type="info" @click="dialogFormVisible = false" style="width: 150px;">Close</el-button>
                </template>
            </el-dialog>
        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onBeforeMount, onMounted, nextTick } from 'vue';
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ElMessage, ElMessageBox } from 'element-plus'
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();

    const showMain = ref(true);//顯示主頁面
    const showSetting = ref(false);//顯示設定頁面
    const dialogTitle = ref('[Parameters]');//dialog標題
    const dialogFormVisible = ref(false);//顯示dialog
    const IDdisabled = ref(false);//編輯時ID狀態
    const Roledisabled = ref(false); //公司角色不是門店時才可編輯
    const formRef = ref(null);
    const formData = ref(null);

    const compOptions = ref([]);
    const userOptions = ref([]);
    const funcOptions = ref([]);

    const searchForm = reactive({
        VENDOR_ID: localStorage.getItem('VendorId'),
        Date: [new Date(), new Date()],
        START_DATE: '',
        END_DATE: '',
        USER_ID: '',
        SYS_FUNC: '',
    });

    const form = ref({
        FIELD_1: '',
        FIELD_2: '',
        FIELD_3: '',
        FIELD_4: '',
    });

    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table

    const onLoadTable = () => {
        $api.GET('/api/LogEvent/GetTableData', searchForm
        ).then((response) => {
            tabulator.value.setData(response);
        });
    }

    const onParamClick = (e, cell) => {
        formData.value = JSON.parse(JSON.stringify(cell.getData()));

        dialogFormVisible.value = true;
    }

    const onSearch = () => {
        if (searchForm.Date != null) {
            searchForm.START_DATE = searchForm.Date[0].toLocaleString('zh-TW', { hour12: false }).split(' ')[0];
            searchForm.END_DATE = searchForm.Date[1].toLocaleString('zh-TW', { hour12: false }).split(' ')[0];
        } else {
            searchForm.START_DATE = '';
            searchForm.END_DATE = '';
        }
        onLoadTable();
    }

    const onBack = () => {
        showMain.value = true;
        showSetting.value = false;
    }

    const onDialogOpen = () => {
        nextTick(() => {
            form.value = formData.value;
        })
    }

    const ReportIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-029747aa=""><path fill="currentColor" d="M192 128v768h640V128H192zm-32-64h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32zm160 448h384v64H320v-64zm0-192h192v64H320v-64zm0 384h384v64H320v-64z"></path></svg></i>';
    }

    const getOptions = async () => {
        // 公司/門店下拉
        $api.GET('/api/Outlet/GetCompOptions', {
            CUST_CODE: localStorage.getItem('CustCode'),
            VENDOR_ID: localStorage.getItem('VendorId'),
            ROLE_TYPE: localStorage.getItem('VendorType')
        }).then((response) => {
            compOptions.value = response;
        });

        // 使用者下拉
        $api.GET('/api/OutletUser/GetUserOptions', {
            VENDOR_ID: searchForm.VENDOR_ID
        }).then((response) => {
            userOptions.value = response;
        });

        //功能項目下拉
        $api.GET('/api/SysFunc/GetFuncOptions', {
            VENDOR_ID: searchForm.VENDOR_ID
        }).then((response) => {
            funcOptions.value = response;
        });
    };

    onBeforeMount(() => {
        //options
        getOptions();

        if (localStorage.getItem("VendorType") == "門店") {
            Roledisabled.value = true;
        } else {
            Roledisabled.value = false;
        }
    });

    onMounted(() => {
        //instantiate Tabulator when element is mounted
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "calc(100vh - 392px)", //do not let table get bigger than the height of its parent element
            columnHeaderVertAlign: "middle", //align header contents to middle of cell
            pagination: true,       //paginate the data
            paginationSize: 50,         //allow 50 rows per page of data
            paginationSizeSelector: [50, 100, 200],
            columns: [
                { title: "No", formatter: "rownum", width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "操作日期時間", field: "EVENT_TIME", headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                {
                    title: "使用者", field: "USER_CODE", headerHozAlign: "center", hozAlign: "center", headerSort: false, formatter: function (cell, formatterParams) {
                        return cell.getRow().getData().USER_CODE + '<br/>' + cell.getRow().getData().USER_NAME;
                    }
                },
                {
                    title: "功能項目", field: "JOB_CODE", headerHozAlign: "center", hozAlign: "center", headerSort: false,
                    formatter: function (cell, formatterParams) {
                        if (cell.getRow().getData().FUNC_DESC == null) cell.getRow().getData().FUNC_DESC = "";
                        return cell.getRow().getData().JOB_CODE + '<br/>' + cell.getRow().getData().FUNC_DESC;
                    }
                },
                { title: "Form", field: "URL_ADDR", headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "Event", field: "EVENT_DESC", headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "Parameters", field: "param", formatter: ReportIcon, width: 100, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false, cellClick: onParamClick },
            ],
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });
    })

</script>

<style></style>
